import { useState } from 'react';
import { useStripeProduct } from '@/hooks/use-stripe-product';
import moment from 'moment';

interface StripeProductProps {
  priceId: string;
}

export function StripeProduct({ priceId } : StripeProductProps) {
  const { data } = useStripeProduct({priceId});
  const trialEnd = moment().add(30, 'days').format('Do MMMM, YYYY');

  return (
    <section
    aria-labelledby="summary-heading"
    className="bg-indigo-900 py-12 text-indigo-300 md:px-10 col-start-2 row-start-1"
  >
    <div className="mx-auto max-w-2xl px-4 lg:max-w-none lg:px-0">
      <h2 id="summary-heading" className="sr-only">
        Order summary
      </h2>

      <ul role="list" className="divide-y divide-white divide-opacity-10 text-sm font-medium">
        <li key={12345} className="flex items-start space-x-4 py-6">
            {/* <img
              src={product.imageSrc}
              alt={product.imageAlt}
              className="h-20 w-20 flex-none rounded-md object-cover object-center"
            /> */}
            <div className="flex-auto space-y-1">
              <h2 className="text-white text-3xl font-bold">{data?.name}</h2>
              <p>{data?.description}</p>
            </div>
          </li>
        {/* {products.map((product) => (
          <li key={product.id} className="flex items-start space-x-4 py-6">
            <img
              src={product.imageSrc}
              alt={product.imageAlt}
              className="h-20 w-20 flex-none rounded-md object-cover object-center"
            />
            <div className="flex-auto space-y-1">
              <h3 className="text-white">{product.name}</h3>
              <p>{product.color}</p>
              <p>{product.size}</p>
            </div>
            <p className="flex-none text-base font-medium text-white">{product.price}</p>
          </li>
        ))} */}
      </ul>

      <dl>
        <dt className="text-sm font-medium">free trial</dt>
        <dd className="mt-1 text-3xl font-bold tracking-tight text-white">30 days</dd>
      </dl>

      <dl className="mt-4">
        <dt className="text-sm font-medium">then due monthly, starting on {trialEnd}</dt>
        <dd className="mt-1 text-3xl font-bold tracking-tight text-white">€{data?.price?.unit_amount/100}</dd>
      </dl>

      <dl className="mt-4 space-y-6 border-t border-white border-opacity-10 pt-6 text-sm font-medium">
        <div className="flex items-center justify-between">
          <dt>Subtotal</dt>
          <dd>€{data?.price?.unit_amount/100}</dd>
        </div>

        <div className="flex items-center justify-between">
          <dt>Taxes</dt>
          <dd>€0.00</dd>
        </div>

        <div className="flex items-center justify-between border-t border-white border-opacity-10 pt-6 text-white">
          <dt className="text-base">Total</dt>
          <dd className="text-base">€{data?.price?.unit_amount/100}</dd>
        </div>
      </dl>
    </div>
  </section>
  )
}
